"use strict";
/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.KrakenSDKError = void 0;
/** The base class for all HTTP error responses */
class KrakenSDKError extends Error {
    constructor(message, httpMeta) {
        super(message);
        this.statusCode = httpMeta.response.status;
        this.body = httpMeta.body;
        this.headers = httpMeta.response.headers;
        this.contentType = httpMeta.response.headers.get("content-type") || "";
        this.rawResponse = httpMeta.response;
        this.name = "KrakenSDKError";
    }
}
exports.KrakenSDKError = KrakenSDKError;
//# sourceMappingURL=krakensdkerror.js.map